<template>
  <v-app id="inspire">
    <v-app-bar
      fixed
      :color="this.$vuetify.theme.themes.light.barraSuperior"
      :class="this.$vuetify.theme.themes.light.barraText"
      app
    >
      <v-app-bar-nav-icon @click="login">
        <v-icon size="48" :class="this.$vuetify.theme.themes.light.barraText">mdi-chevron-left</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>Vagas disponíveis</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main app>
      <v-container fluid grid-list-md class="pl-1 pr-1">
        <v-layout row wrap align-center justify-center>
          <v-flex xs12 v-for="(vaga, vagakey) in vagas" :key="vagakey">
            <v-card style="border-radius: 10px" class="pa-2 elevation-5">
              <v-card-text class="text-left">
                <v-layout row wrap justify-space-between align-center class="hidden-sm-and-down">
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{ vaga.descricao }}</h2>
                      </v-flex>
                      <v-flex xs6 lg3>
                        <h4>{{ vaga.cidade }}</h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <div style="text-align: center">
                    <v-btn color="primary" @click="showDialog(vaga)">
                      <v-icon left>mdi-account-details</v-icon>Detalhar vaga
                    </v-btn>
                  </div>
                </v-layout>
                <v-layout row wrap justify-space-between align-center class="hidden-md-and-up">
                  <v-flex>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{ vaga.descricao }}</h2>
                      </v-flex>
                      <v-flex xs6 lg3>
                        <h4>{{ vaga.cidade }}</h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex style="text-align: center">
                    <v-btn block color="primary" @click="showDialog(vaga)">
                      <v-icon left>mdi-account-details</v-icon>Detalhar vaga
                    </v-btn>
                    <p>
                      {{
                      moment(vaga.dtRequisicao, "yyyy-MM-dd").format(
                      "DD/MM/YYYY"
                      )
                      }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card class="text-left">
        <v-card-title class="headline grey lighten-2" primary-title>
          Detalhes
          <v-spacer></v-spacer>
          <v-progress-circular v-if="showProgress" indeterminate color="primary"></v-progress-circular>
        </v-card-title>

        <v-card-text class="pt-5">
          <p>Cargo: {{ vaga.cargo }}</p>
          <p>Setor: {{ vaga.setor }}</p>
          <p>Cidade: {{ vaga.cidade }}</p>
          <p>Vagas: {{ vaga.numVagas }}</p>
          <p>Requisitos: {{ vaga.Requisitos }}</p>
        </v-card-text>
        <template v-if="vaga.beneficios != ''">
          <v-divider></v-divider>
          <v-card-title v-if="vaga.beneficios != ''">Benefícios</v-card-title>
          <v-card-text class="text-left pa-0 pl-5 pr-3">
            <p style="white-space: pre;">{{ vaga.beneficios }}</p>
          </v-card-text>
        </template>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false" :disabled="showProgress">Fechar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="candidatar(vaga)"
            :disabled="showProgress"
          >Candidatar-se</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogLogin" width="500">
      <cgi-login tipo="vaga" :codVaga="codVaga" @close="closeLoginDialog" @home="setComponent"></cgi-login>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="8000"
      :color="snackbarColor"
      :vertical="false"
    >
      {{ mensagem }}
      <v-btn text @click="snackbar = false">OK</v-btn>
    </v-snackbar>
    <cgi-footer />
  </v-app>
</template>

<script>
import Login from "./Login";
import Service from "@/services/service.js";
import moment from "moment";
import CardLoginVue from "./CardLogin.vue";
import Footer from "./Footer.vue";
export default {
  components: {
    "cgi-login": CardLoginVue,
    "cgi-footer": Footer,
  },
  data: () => ({
    mensagem: "",
    showProgress: false,
    snackbar: false,
    snackbarColor: "red",
    dialog: false,
    service: new Service(),
    showSenha: false,
    senha: null,
    mask: "###.###.###-##",
    cpf: null,
    print: console.log,
    codPessoa: 0,
    vaga: {
      Requisitos: null,
      cargo: null,
      cidade: null,
      codRequisicao: null,
      descricao: null,
      dtRequisicao: null,
      numVagas: null,
      setor: null,
    },
    vagas: [],
    codVaga: 0,
    dialogLogin: false,
  }),
  async mounted() {
    var response;
    response = await this.service.getVagas();
    this.vagas = response.data.ttRequisicao;
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    login() {
      this.$emit("home", Login);
    },
    moment: function () {
      return moment();
    },
    goLogin() {
      this.$emit("login", Login);
    },
    showDialog(vaga) {
      this.dialog = true;
      this.vaga = vaga;
    },
    async candidatar(vaga) {
      if (localStorage.getItem("codPessoa") !== null) {
        this.showProgress = true;
        var response = await this.service.setVaga(vaga.codRequisicao);
        if (response.data.retorno[0].estatus === "Sucesso") {
          this.showSucesso();
        } else {
          this.showErro(response.data.retorno[0].msgErro);
        }
      } else {
        console.log(vaga);
        this.codVaga = vaga.codRequisicao;
        this.dialog = false;
        this.dialogLogin = true;
      }
    },
    setComponent(val) {
      this.$emit("home", val);
    },
    closeLoginDialog(val, msg) {
      if (val) {
        this.showSucesso();
      } else {
        this.showErro(msg);
      }
    },
    showSucesso() {
      this.dialog = false;
      this.dialogLogin = false;
      this.mensagem = "Inscrito na vaga";
      this.snackbarColor = "green";
      this.snackbar = true;
      this.showProgress = false;
    },
    showErro(msgErro) {
      this.dialog = false;
      this.dialogLogin = false;
      this.mensagem =
        msgErro ??
        "Algo ocorreu, tente novamente ou entre em contato com a empresa.";
      this.snackbarColor = "red";
      this.snackbar = true;
      this.showProgress = false;
    },
  },
  props: {
    source: String,
  },
};
</script>
